<template>
  <button
    type="button"
    class="home-kanban-card"
    :class="{
      'home-kanban-card--selected': selected,
      'home-kanban-card--compact': !rows.length,
      [`home-kanban-card--${tone}`]: Boolean(tone),
    }"
    @click="emit('select')"
  >
    <div class="home-kanban-card__header">
      <div class="home-kanban-card__title">{{ title }}</div>
      <span
        v-if="tag"
        class="home-kanban-card__tag"
      >{{ tag }}</span>
    </div>
    <template v-if="rows.length">
      <div
        v-for="(row, idx) in rows"
        :key="idx"
        class="home-kanban-card__row"
      >
        <span class="home-kanban-card__label">{{ row.label }}</span>
        <span class="home-kanban-card__value">{{ row.value }}</span>
      </div>
    </template>
  </button>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  tag: { type: String, default: '' },
  rows: { type: Array, default: () => [] },
  selected: { type: Boolean, default: false },
  tone: { type: String, default: '' },
})

const emit = defineEmits(['select'])
</script>
